export const DAYS_OF_WEEK = [
  {
    value: 'MONDAY',
    label: 'Monday',
  },
  {
    value: 'TUESDAY',
    label: 'Tuesday',
  },
  {
    value: 'WEDNESDAY',
    label: 'Wednesday',
  },
  {
    value: 'THURSDAY',
    label: 'Thursday',
  },
  {
    value: 'FRIDAY',
    label: 'Friday',
  },
  {
    value: 'SATURDAY',
    label: 'Saturday',
  },
  {
    value: 'SUNDAY',
    label: 'Sunday',
  },
];

export const SUPPLIER_STATUSES = [
  {
    value: 'ACTIVE',
    label: 'Active',
  },
  {
    value: 'INACTIVE',
    label: 'Inactive',
  },
  {
    value: 'BLACKLISTED',
    label: 'Blacklisted',
  },
];
